<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
body {
  margin: 0;
}
img {
  max-width: 100%;
}

form {
  background-color: #eee;
  padding: 2rem 4rem;
  overflow: hidden;
}

.row {
  display: flex;
  margin-right: -3rem;
  overflow: hidden;
  flex-wrap: wrap;
}
.row > * {
  flex: 1;
  padding-right: 3rem !important;
}

.section {
  border-top: 1px solid #999;
  margin-top: 3rem;
  padding-top: 1rem;
}

.field {
  font-size: 1.1rem;
  margin-bottom: 2rem;
  padding: 0;
  position: relative;
}
.field--small {
  max-width: 30%;
}

label {
  color: #666;
  display: block;
  font-family: 'courier new', monospace;
  text-transform: uppercase;
  font-size: 85%;
  letter-spacing: 0.05em;
  padding-bottom: 0.75rem;
}
.control {
  flex: 1;
  margin-bottom: 1rem;
}
input, button, textarea, select {
  background-color: #fff;
  border: 0;
  box-sizing: border-box;
  color: #000;
  font: inherit;
  margin: 0;
  padding: 1rem 1.5rem;
  width: 100%;
  outline: none;
  border-bottom: 2px solid transparent;
}
input {
  min-width: 15rem;
}
input:focus, button:focus, textarea:focus, select:focus {
  border-bottom: 2px solid #06c;
}
select {
  padding: 0;
}
.select {
  background-color: #fff;
  padding: 1rem;
  position: relative;
}
option {
  padding: 0.5em 1rem;
}
button {
  display: inline-block;
  background: #000;
  color: #fff;
  cursor: pointer;
  min-width: 8rem;
  width: auto;
  margin-right: 1rem;
}

.app-header {
  background: #222;
  box-sizing: border-box;
  color: #fff;
  display: flex;
  font-family: 'courier new', monospace;
  height: 4rem;
  padding: 1rem;
  letter-spacing: 0.05em;
  align-items: center;
  font-size: 90%;
  justify-content: space-between;
}
.app-header a {
  color: #fff;
  text-decoration: none;
}

.reorder {
  position: absolute;
  left: -3.4rem;
  color: #666;
  font-family: 'system-ui', monospace;
  width: 1em;
  top: -0.5em;
  font-size: 1.3rem;
}

.reorder a {
  text-decoration: none;
  color: inherit;
  display: inline-block;
  padding: 0.5em;
}

.delete {
  color: red;
  text-decoration: none;
  font-family: 'courier new', monospace;
  border: 0;
  position: absolute;
  top: 0.25rem;
  right: 0.25rem;
  width: 1em;
  height: 1em;
  display: flex;
  align-items: center;
  justify-content: center;
}
.delete:hover {
  background: red;
  color: #fff;
}

.underline {
  text-decoration: underline;
}

.ql-toolbar button {
  min-width: 0;
}
.ql-editor {
  background: #fff;
}
</style>



// WEBPACK FOOTER //
// src/App.vue